export enum GuideTypes {
  CHANGE_HOMEGUIDE = '@showGuide/CHANGE_HOMEGUIDE',
}

export interface IShowGuide {
  showHomeGuide: boolean
}
